export const NewsKeys = {
    all: ['news'] as  const,
    lastNews: () => [...NewsKeys.all, 'last'] as const,
    detail: (id:number) => [...NewsKeys.all, 'detail', `${id}`] as const
};